import { useStore } from 'react-redux';
import { useSurveyForField } from './useSurveyForField';
import { PrescriptionJob } from './PrescriptionJob';
import { SurveyLayer } from '../../constants/SurveyLayers';
import WebAPIUtils from '../../WebAPIUtils';

export const useBulkPrescriptionClassifications = () => {
  const store = useStore();
  const { getSurveyForFieldAndLayer } = useSurveyForField();
  const farmId = store.getState().farm.farm.farmId;

  const fetchClassificationForJob = async (bulkJob: PrescriptionJob, layer: SurveyLayer) => {
    const survey = getSurveyForFieldAndLayer(bulkJob.fieldId, layer);
    const classifications = await WebAPIUtils.getClassificationValues(
      farmId,
      bulkJob.fieldId,
      null,
      layer,
      survey
    );
    return { [bulkJob.fieldId]: { classifications, survey } };
  };

  const fetchDemandForBulkPrescription = async (layer: SurveyLayer) => {
    const bulkPrescriptionJobs: PrescriptionJob[] =
      store.getState().prescription.bulkPrescription.currentJobs;
    const results = await Promise.all(
      Object.values(bulkPrescriptionJobs).map(async (job: PrescriptionJob) =>
        fetchClassificationForJob(job, layer)
      )
    );

    return Object.assign({}, ...results);
  };

  return { fetchDemandForBulkPrescription };
};
